/**
 * Removes a match index from a link.
 *
 * @param {Link} link
 * @param {number} index
 */
export function removeMatch(link, index) {
    const indexOf = link.match.indexOf(index);
    if (indexOf >= 0) {
        link.match.splice(indexOf, 1);
    }
    return link;
}
//# sourceMappingURL=removeMatch.js.map